// Pacific-time date helpers for the React UI.
//
// The browser running this app is in California, so its local time IS
// Pacific — meaning `d.getHours()`, `d.toLocaleDateString()`, parsing
// "YYYY-MM-DDTHH:MM" without a Z, etc. all naturally return Pacific
// values. The thing to avoid is `d.toISOString().slice(0, 10)`, which
// always returns the UTC date — so at 5 PM Pacific on May 18, that
// pattern returns "2026-05-19" and the UI jumps a day.

// Returns YYYY-MM-DD for `d` in the browser's local timezone (Pacific).
export function localDateString(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Today as YYYY-MM-DD in Pacific time.
export function todayLocal() {
  return localDateString(new Date());
}

// `offsetDays(0)` is today, `offsetDays(-1)` yesterday, etc. — all in
// Pacific time, all returned as YYYY-MM-DD strings.
export function offsetDays(offset) {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return localDateString(d);
}
